@if (settings) {
  <div class="setting-section">
    <div class="setting-title">{{ 'settings.theme' | translate }}</div>
    <div class="setting-values">
      <div class="setting-value pointer" (click)="save('app.theme', 'light')" tabindex="0">
        <div class="color-dark">{{ 'common.light' | translate }}</div>
        <app-control-radio-button [checked]="settings['app.theme'] === 'light'" />
      </div>
      <div class="setting-value pointer" (click)="save('app.theme', 'dark')" tabindex="0">
        <div class="color-dark">{{ 'common.dark' | translate }}</div>
        <app-control-radio-button [checked]="settings['app.theme'] === 'dark'" />
      </div>
    </div>
  </div>

  <app-separator [type]="'horizontal'" [style]="'solid'" />

  <div class="setting-section">
    <div class="setting-title">{{ 'settings.language' | translate }}</div>
    <div class="setting-values">
      <div class="setting-value pointer" (click)="save('app.lang', 'ru')" tabindex="0">
        <div class="color-dark">{{ 'settings.languages.ru' | translate }}</div>
        <app-control-radio-button [checked]="settings['app.lang'] === 'ru'" />
      </div>
      <div class="setting-value pointer" (click)="save('app.lang', 'en')" tabindex="0">
        <div class="color-dark">{{ 'settings.languages.en' | translate }}</div>
        <app-control-radio-button [checked]="settings['app.lang'] === 'en'" (click)="save('app.lang', 'en')" />
      </div>
    </div>
  </div>

  <app-separator [type]="'horizontal'" [style]="'solid'" />

  <div class="setting-section">
    <div class="setting-title">{{ 'settings.sound' | translate }}</div>
    <div class="setting-values">
      <div class="setting-value pointer" (click)="save('terminal.dealsSound', !settings['terminal.dealsSound'])" tabindex="0">
        <div class="color-dark">{{ 'settings.dealsSound' | translate }}</div>
        <app-control-switcher [checked]="settings['terminal.dealsSound']" />
      </div>
    </div>
  </div>
}
